import { AbstractServiceRecord } from "./abstract-service-record"
import { IGenericAccessor } from '@common/interfaces/i-generic-accessor';
import { DataType } from '@common/enums/data-type';
import { IServiceCollectionScript } from '@common/interfaces/i-service-collection-script';
import { ServiceRecord } from '@common/data-models/service/service-record';
import { ServiceCollectionFactory } from '@common/data-models/service/service-collection-factory';
import { KnownPropertyTypes } from '@common/enums/known-property-types';

let metaData = {
    BackCumeTime: DataType.STRING,
    BackCumeTimeFormatted: DataType.STRING,
    BackOverUnder: DataType.STRING,
    BackTime: DataType.DATE,
    BackTimeFormatted: DataType.STRING,
    Break: DataType.BOOL,
    CBreak: DataType.BOOL,
    CollectionsCollection: DataType.OBJECT,
    CumeTime: DataType.STRING,
    CumeTimeFormatted: DataType.STRING,
    Float: DataType.BOOL,
    FrontOverUnder: DataType.STRING,
    FrontTime: DataType.DATE,
    FrontTimeFormatted: DataType.STRING,
    HasYellowTimingBar: DataType.BOOL,
    IsFrozen: DataType.BOOL,
    IsRowFlashing: DataType.BOOL,
    IsTimingBarSelected: DataType.BOOL,
    NotForBroadcast: DataType.BOOL,
    PageNum: DataType.STRING,
    ScriptOrder: DataType.NUMBER
};

KnownPropertyTypes.setFor(metaData);

export class ServiceCollectionScript implements IGenericAccessor, IServiceCollectionScript {
    public BackCumeTime?: string;
    public BackCumeTimeFormatted?: string;
    public BackOverUnder?: string;
    public BackTime?: string;
    public BackTimeFormatted?: string;
    public Break?: boolean;
    public CBreak?: boolean;
    public CollectionsCollection?: any;
    public CumeTime?: string;
    public CumeTimeFormatted?: string;
    public Float?: boolean;
    public FrontOverUnder?: string;
    public FrontTime?: string;
    public FrontTimeFormatted?: string;
    public HasYellowTimingBar?: boolean;
    public IsFrozen?: boolean;
    public IsRowFlashing?: boolean;
    public IsTimingBarSelected?: boolean;
    public NotForBroadcast?: boolean;
    public PageNum?: string;
    public RecordPointer: AbstractServiceRecord;
    public ScriptOrder?: number;

    public getOwnMetaData(): { [id: string]: number } {
        let objectKeys = Object.keys(this);
        let ret = {};
        for (let prop of objectKeys) {
            if(metaData[prop]) ret[prop] = metaData[prop];
        }
        return (ret);
    }

    public getMetaData(): { [id: string]: number } {
        let ret = this.getOwnMetaData();
        let recordPointerMetaData = this.RecordPointer.getMetaData();

        // merge
        for (let p in recordPointerMetaData) {
            if (!ret[p]) ret[p] = recordPointerMetaData[p];
        }

        return ret;
    }

    public getRawValue(field: string): any {
        if (this.getOwnMetaData()[field]) {
            //console.log("00. " + field + " -> " + this.getOwnMetaData()[field]);
            return this[field];
            //return eval("this." + field);
        } else return this.RecordPointer.getRawValue(field);
    }

    public instantiateChildren() {
        // TODO: all collections handling
        if (this.RecordPointer.ListData.Type == 3) {
            // Record
            this.RecordPointer = Object.assign(new ServiceRecord, this.RecordPointer);
        } else {
            // Collection
            this.RecordPointer = Object.assign(ServiceCollectionFactory.newServiceCollectionRecord(), this.RecordPointer);
        }
        this.RecordPointer.instantiateChildren();
    }
}

ServiceCollectionFactory.newServiceCollectionScript = () => {
    return new ServiceCollectionScript();
};
